import { notNull } from "./notNull";
import { notUndefined } from "./notUndefined";

export const notNullish = <T>(item: T | undefined | null): item is T =>
  notNull(item) && notUndefined(item);
